'use strict';

exports.__esModule = true;

exports.default = function () {
  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
/* eslint-disable camelcase, no-undef */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/nonce.js
// module id = ./node_modules/styled-components/lib/utils/nonce.js
// module chunks = 5217438866945042000 7356694376651505000 9453687551911655000 13994203391546835000